<template>
  <v-dialog
    v-model="showModal"
    :max-width="500"
    scrollable
  >
    <v-card>
      <v-card-title>
        #{{ selectedReservationId }} No-Shows
      </v-card-title>
      <v-divider />
      <v-card-text>
        <api-errors
          :errors="errors"
          class="ft-negmt-3 ft-negmx-3"
        />

        <v-list>
          <v-list-item
            v-for="(item) of applicableDetails"
            :key="item.id"
            two-line
            @click="toggleShow(item)"
          >
            <v-list-item-avatar>
              <img
                v-if="item.member"
                :src="getPhoto(item.member)"
              >
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ item.name }} <span v-if="!reservation.discreteCovers && reservation.details.length > 1"> + {{ reservation.details.length -1 }}</span></v-list-item-title>
              <v-list-item-subtitle><span v-if="guestTypeMap[item.guestTypeId] || (item.member && item.member.memNum)">({{ (item.member && item.member.memNum) || guestTypeMap[item.guestTypeId].name }})</span></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action v-if="reservation.discreteCovers || reservation.details.length === 1">
              <v-checkbox
                :loading="item.loading"
                :input-value="item.noShow"
                :false-value="false"
                :true-value="true"
                color="error"
                @input="toggleShow(item)"
              />
            </v-list-item-action>
            <v-list-item-action v-else>
              <v-autocomplete
                v-model="noShowCount"
                class="pa-0"
                :single-line="true"
                :hide-details="true"
                :items="noShowSelectList"
              />
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          text
          @click="hideModal"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {helpers, errorHandler, apiHelpers, rules} from '@/ft-vue-core'

const {getMemberPhoto, setItems} = helpers

export default {
  name: 'ReservationNoShow',
  components: {
  },
  mixins: [apiHelpers, rules, errorHandler],
  props: {
    value: Number
  },
  data: function () {
    return {
      selectedReservationId: null,
      guestTypes: [],
      reservation: {
        id: null,
        discreteCovers: null,
        details: []
      }
    }
  },
  computed: {
    showModal: {
      get () {
        return !!this.selectedReservationId
      },
      set (val) {
        if (!val) this.selectedReservationId = null
        this.$emit('input', this.selectedReservationId)
      }
    },
    applicableDetails () {
      const result = !this.reservation.discreteCovers ? this.reservation.details.filter((d, i) => i < 1) : this.reservation.details
      console.warn('applicableDetails', result, this.reservation, this.reservation.details)
      return result
    },
    noShowSelectList () {
      const result = []
      for (let i = 0, l = this.reservation.details.length; i <= l; i++) {
        result.push({value: i, text: '' + i})
      }
      return result
    },
    noShowCount: {
      get () {
        const result = this.reservation.details.reduce((acc, d) => acc + (d.noShow ? 1 : 0), 0)
        return result
      },
      set (val) {
        const currentCount = this.reservation.details.reduce((acc, d) => acc + (d.noShow ? 1 : 0), 0)
        const details = this.reservation.details
        const l = details.length
        if (val === currentCount || !l) return
        const items = []
        const start = l - val
        for (let i = 0; i < l; i++) {
          const detail = details[i]
          items.push({
            id: detail.id,
            reservationId: this.selectedReservationId,
            show: i < start
          })
        }
        const command = {
          command: 'diningReservationDetailSetShow',
          load (r) {
            this.loadReservation(this.selectedReservationId)
          },
          loading: this.setIsLoading
        }
        this.$ftAPI().put(this.addResourceErrorHandler(command), items)
      }
    },
    guestTypeMap () {
      return (this.guestTypes || []).reduce((result, guestType) => {
        result[guestType.id] = guestType
        return result
      }, {})
    }
  },
  watch: {
    value (val) {
      if (val !== this.selectedReservationId) {
        this.selectedReservationId = val
      }
    },
    selectedReservationId (val, oldVal) {
      if (val !== oldVal) {
        if (val) {
          this.reservation.details = []
          this.resetApiErrors()
          this.loadReservation(val)
        } else {
          this.$emit('close')
        }
      }
    }
  },
  created () {
    this.selectedReservationId = this.value
  },
  methods: {
    getPhoto (member) {
      const memberRecord = member || {}
      return getMemberPhoto(memberRecord.activePhoto, memberRecord.gender)
    },
    hideModal () {
      this.showModal = false
      this.selectedReservationId = false
    },
    openModal () {
      this.showModal = true
    },
    toggleShow (item) {
      if (!this.reservation.discreteCovers) return
      const command = {
        command: 'diningReservationDetailSetShow',
        load (r) {
          item.noShow = !item.noShow
          item.loading = false
        },
        cancelled () {
          item.loading = false
        },
        loading: this.setIsLoading
      }
      item.loading = true
      this.$ftAPI().put(this.addResourceErrorHandler(command), {
        id: item.id,
        show: item.noShow, // Yeah, it's confusing, but this is right.  item.noShow shouldn't have been flipped yet
        reservationId: item.reservationId
      })
    },
    loadReservation (id) {
      const commands = [
        {
          command: 'guestType',
          load: this.guestTypes,
          loading: this.setIsLoading,
          params: {filter: [{field: 'activityId', operator: 'EQUAL', values: [9999]}]}
        },
        {
          command: 'diningReservation',
          load (r) {
            for (let i of r.details) {
              i.noShow = i.show === undefined || i.show === null ? false : !i.show
            }
            setItems(this.reservation, r)
          },
          params: {include_fields: ['details', 'cancelledDetails', 'diningReservationDetail.member'], id: id, children: true},
          loading: this.setIsLoading
        }
      ]
      this.$ftAPI().get(this.addResourceErrorHandler(commands))
    }
  }
}
</script>
